import Header from 'modules/header/wholesaler/main';

import {Form, Formik} from 'formik';
import AuctionFormComponent from 'components/forms/auction';
import {initialValues} from './utilities/initialValues';
import {schema} from './utilities/validationSchema';
import {formDataCreator} from '../../utilities/formDataCreatot';
import {useWholesaler} from 'context/wholesaler';
import usePostAd from '../../hooks/usePostAd';
import useSetAnswers from 'pages/farm/createAd/form/owner/simple/hooks/useSetAnswers';
import {useState} from 'react';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {WholesalerEvent} from 'utilities/helper/googleAnalitics/EventHelper';

const AuctionForm = () => {
  const {wholesaler} = useWholesaler();
  const {isLoading, mutate} = usePostAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <div className="mt-8">
        <p className=" text-gray-6 font-extrabold my-3">تعیین قیمت</p>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, wholesaler);
          payload.append('price', values.price);
          payload.append('duration', values.duration);
          payload.append('duration_unit', values.duration_unit);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
          googleAnalyticsInstance.eventGoogleAnalytics(
            WholesalerEvent.addedAuction,
          );
        }}
      >
        {({values}) => (
          <Form className="px-3 pb-4">
            <AuctionFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={wholesaler?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AuctionForm;
